import { NgModule, isDevMode } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { AppComponent } from './app.component';
import { AuthGuard } from './core/auth.guard';
import { StaffHomeComponent } from './staff';
import { SelectPatientComponent } from './select-patient.component';
import { UserNotAuthorizedComponent } from './user-not-authorized.component';

const routes: Routes = [

  { path: '', redirectTo: 'select-patient', pathMatch: 'full' },  
  { path: 'select-patient', component: SelectPatientComponent },
  { path: 'not-authorized', component: UserNotAuthorizedComponent },
  { 
    path: 'auth', 
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) ,
    data: { preload: true } // Mark for preloading
  },
  { 
    path: 'offline', 
    loadChildren: () => import('./offline/offline.module').then(m => m.OfflineModule),
    data: { preload: true } // Mark for preloading
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledNonBlocking',
    preloadingStrategy: PreloadAllModules, // Preload all modules marked with preload: true
    //enableTracing: isDevMode()
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
